import { render, staticRenderFns } from "./GuideBlockForm.vue?vue&type=template&id=1634edc2"
import script from "./GuideBlockForm.vue?vue&type=script&lang=js"
export * from "./GuideBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports